import React, { Component } from 'react'
import Indicator from './Indicator'
import { extendParentClass } from '../../../../utils/classes'

export class Indicators extends Component {
  baseClass = extendParentClass.bind(this)('indicators')

  getPrice = () => {
    const { price } = this.props
    const roundedPrice = price.toFixed(2)
    return `$${roundedPrice}`
  }

  render() {
    const { monthlyTextMessages } = this.props
    return (
      <div className={this.baseClass}>
        <Indicator
          name="Price"
          value={this.getPrice()}
          parentClass={this.baseClass}
        />
        <Indicator
          name="Text Messages"
          value={monthlyTextMessages}
          parentClass={this.baseClass}
        />
      </div>
    )
  }
}

export default Indicators
